import { render, staticRenderFns } from "./PostingCreate.vue?vue&type=template&id=166849e6"
import script from "./PostingCreate.vue?vue&type=script&lang=js"
export * from "./PostingCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports